import LayoutPublic from '@/components/layout-public';
import { Button, Link, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';

export default function Support() {
  const theme = useTheme();

  return (
    <LayoutPublic loading={false}>
      <Box
        sx={{
          // height: '70vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          maxWidth: 700,
          margin: '0 auto',
        }}
      >
        <div>
          <Typography variant="h2" sx={{ textAlign: 'center' }}>
            Support ViteBike ❤️
          </Typography>
          <Typography variant="h5" mt={5} sx={{ textAlign: 'center' }}>
            Hello friend and fellow Strava user. I&apos;m glad you&apos;re here.
            ViteBike is run by a
            {' '}
            <Link href="https://justinwhall.com" target="blank">solo software engineer</Link>
            {' '}
            (me) who is passionate about cycling and building cool things.
            If you like ViteBike and want to support
            me, please consider donating either a one-time or recurring amount. Thank you!
          </Typography>
        </div>
        <Box mt={4}>
          <Button
            size="large"
            color="primary"
            variant="contained"
            href="https://donate.stripe.com/4gw01q5ebcKL3Ic144"
            target="_blank"
            size="xlarge"
          >
            One time donation
          </Button>
        </Box>
        <Box mt={7} textAlign="center">
          <Typography variant="h3" color={theme.palette.secondary.main} mb={4} sx={{ textAlign: 'center' }}>
            Annual Support
          </Typography>
          <Box mt={2}>
            <Button
              color="primary"
              variant="contained"
              href="https://buy.stripe.com/3cs01qayvdOP5QkeUW"
              target="_blank"
              size="xlarge"
            >
              25USD a year
            </Button>
          </Box>
          <Box mt={2}>

            <Button
              color="primary"
              variant="contained"
              href="https://buy.stripe.com/14k9C07mjdOP0w028b"
              target="_blank"
              size="xlarge"
            >
              10USD a year
            </Button>
          </Box>
          <Box mt={2}>

            <Button
              color="primary"
              variant="contained"
              href="https://buy.stripe.com/00g8xW6ifcKLbaEbIM"
              target="_blank"
              size="xlarge"
            >
              5USD a year
            </Button>
          </Box>
        </Box>
      </Box>
    </LayoutPublic>
  );
}
